import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ErrorHandler, provideBrowserGlobalErrorListeners, type ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { requestInterceptor } from '@copec-gid/gid-arquitectura.seguridad-autorizacion-modulo';

import { AuthSession } from '@core/auth/auth-session';
import { TunnelAuthSession } from '@core/auth/tunnel-auth-session';
import { tunnelRetryInterceptor } from '@core/auth/tunnel-retry.interceptor';
import { FEATURES_CONFIG } from '@core/features/features-config';
import { API_CONFIG } from '@core/http/api-config';
import { PRIZE_LINK_HOSTS } from '@core/navigation/prize-link';
import { observabilityInterceptor } from '@core/observability/observability.interceptor';
import { ReportingErrorHandler } from '@core/observability/reporting-error-handler';
import { provideSecurity } from '@core/security/provide-security';
import { sessionHeaderInterceptor } from '@core/security/session-header.interceptor';
import { environment } from '@env/environment';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        observabilityInterceptor,
        ...environment.interceptors,
        tunnelRetryInterceptor,
        requestInterceptor,
        sessionHeaderInterceptor,
      ]),
    ),
    provideSecurity(environment.security),
    { provide: ErrorHandler, useClass: ReportingErrorHandler },
    { provide: AuthSession, useExisting: TunnelAuthSession },
    { provide: API_CONFIG, useValue: environment.api },
    { provide: FEATURES_CONFIG, useValue: environment.features },
    { provide: PRIZE_LINK_HOSTS, useValue: environment.prizeLinkHosts },
    ...environment.providers,
  ],
};
